<mt-filter [filterConfig]="filterConfig" [progressBar]="filterConfig.isLoading" (filterChange)="search($event)"></mt-filter>

<div class="report-container mt-4" *ngIf="reportData$ || message || systemError">
    <div class="header-container">
        <div class="header">
            <div class="float-left">
                <div class="title">
                    {{ 'report-checklist' | lang | uppercase }}
                </div>
            </div>
        </div>
    </div>
    <div [ngClass]="{'body-container': !message && !systemError}">
        <!-- Message -->
        <div class="d-flex flex-row message" *ngIf="message">
            <img class="message-img " appImageSelector [imageType]="'icon'" [imageKey]="'error-red'" alt="error"/>
            <span class="message-text" >{{ message }}</span>
        </div>

        <app-system-error-message *ngIf="!!systemError" [message]="systemError"></app-system-error-message>

        <div class="row" *ngIf="reportData$">
            <div class="col-12">
                <app-checklist-table [data]="reportData$ | async"></app-checklist-table>
            </div>
        </div>
    </div>
</div>
